var map = {
	"./add.svg": "6ae9",
	"./arrow-down-left.svg": "7254",
	"./arrow-down.svg": "9548",
	"./auth-logo.svg": "3d32",
	"./ban-circle.svg": "3e6d",
	"./check-circle.svg": "107b",
	"./clock-rotate-left.svg": "1e7c",
	"./custom-bars.svg": "bc71",
	"./dot-loader.svg": "ec19",
	"./double-save.svg": "596f",
	"./edit-pen.svg": "0170",
	"./empty-grid.svg": "a34d",
	"./error-message.svg": "ab51",
	"./fi-rr-cross.svg": "bd6f",
	"./google.svg": "7b9a",
	"./icon-drop.svg": "e3af",
	"./line-and-point.svg": "389d",
	"./logo.svg": "68f1",
	"./logout.svg": "85c2",
	"./maap-logo-mini.svg": "099c",
	"./mail.svg": "80d8",
	"./menu-icon-chart.svg": "966e",
	"./menu-icon-other.svg": "71a6",
	"./menu-icon-settings.svg": "0b79",
	"./microsoft.svg": "7bc3",
	"./moon.svg": "83e4",
	"./remove.svg": "f98c",
	"./sidebar-logo-full.svg": "28c8",
	"./sidebar-logo-small.svg": "3338",
	"./sms.svg": "94b0",
	"./sun.svg": "2a9d",
	"./telegram.svg": "5c81",
	"./trash.svg": "1d56",
	"./type-search.svg": "d4fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f238";